import { callAPI } from '../network';

export async function getZones (){
  
   const data = await callAPI(
                        null, 
                        'Zone/GetAllZones', 'get');
   return data || [ ];
}
